import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  Autoplay,
  EffectFade,
} from 'swiper';

class CloserLook extends HTMLElement {
  constructor() {
    super();

    this.mainSwiper = null;

    this.imagesEl = this.querySelector('.closer-look__views-images');
  }

  connectedCallback() {
    this.mainSwiper = new Swiper(this.imagesEl.querySelector('.swiper'), {
      slidesPerView: 1,
    });

    this.querySelectorAll('[data-view-target]').forEach((el) => {
      el.addEventListener('click', (e) => {
        const activeFeatures = this.querySelector('.active[data-features]');
        activeFeatures.classList.remove('active');
        activeFeatures.querySelector('closer-look-features').destroy();

        this.querySelector('.active[data-view-target]').classList.remove('active');

        e.target.classList.add('active');

        const features = this.querySelector(`[data-features="${e.target.dataset.viewTarget}"]`);
        features.classList.add('active');
        features.querySelector('closer-look-features').init();

        this.mainSwiper.slideTo(e.target.dataset.viewTarget);
      });
    });

    this.querySelectorAll('[data-feature-target]').forEach((el) => {
      el.addEventListener('click', (e) => {
        console.log('click');
        

        const activeFeatures = this.querySelector('.closer-look__feature.active');
        const activeFeatureCarousel = activeFeatures.querySelector('closer-look-features');

        console.log('activeFeatureCarousel => ', activeFeatureCarousel);

        if(window.matchMedia('(min-width: 768px)').matches) {
          activeFeatureCarousel.swiper.slideTo(Number(e.target.dataset.featureTarget) - 1);
        } else {
          if(activeFeatures.classList.contains('visible')) return;

          activeFeatures.classList.add('visible');

          activeFeatureCarousel.swiper.slideTo(Number(e.target.dataset.featureTarget) - 1);

          document.body.classList.add('site-overflowed');
          const overlay = document.createElement('div');
          overlay.setAttribute('data-overlay', '');
          document.body.appendChild(overlay);
        }
      });
    });

    this.addEventListener('click', this.onCloseClick.bind(this));
  }

  onCloseClick(e) {
    if(e.target.closest('.closer-look__feature-close') === null) return;

    const activeFeatures = e.target.closest('.closer-look__feature.active');

    activeFeatures.classList.remove('visible');

    const overlay = document.querySelector('[data-overlay]');

    document.body.classList.remove('site-overflowed');

    overlay.remove();

  }
}

customElements.define('closer-look', CloserLook);